/**
 * Storage Integrity Module
 * Main entry point for secure localStorage functionality
 * 
 * @version 1.1.0
 * @author SCM Security Team
 * @since Sprint 64
 */

// Core service
export { StorageIntegrityService } from './storage-integrity.service';

// Configuration and types
export { 
  DEFAULT_STORAGE_CONFIG,
  STORAGE_FORMAT_VERSION,
  validateConfig
} from './storage-integrity.config';

// Application-specific configurations
export { 
  getFabricacionesStorageConfig, 
  validateFabricacionesSecurityConfig 
} from './fabricaciones-scm-web.config';

// All interfaces and types
export {
  StorageIntegrityConfig,
  SecureStorageData,
  IntegrityValidationResult,
  IntegrityViolationReason,
  SecurityEvent,
  SecurityEventType,
  StorageOptions,
  RecoveryOptions,
  StorageHealth,
  SecurityEventCallback,
  StorageLogger
} from './storage-integrity.interfaces';